import { Vue, Component, Prop } from "vue-property-decorator";
import { router } from "../../global";

declare global {
    interface Window {
        mgnlContextPath: string;
    }
}

@Component
export default class NewsOverview extends Vue {
    @Prop({ type: String, default: "de" })
    public language!: string;

    @Prop({ type: String, default: "" })
    public allText!: string;

    public categories: any = {};
    public currentCategory = "";
    public currentCategoryDisplayName = "";
    public isInitialized: boolean = false;
    public dropdownOpen: boolean = false;

    private observers: any = [];

    public mounted() {
        getCategories(this.language).then(data => {
            this.categories = data;
            this.updateReferences(this.$route.params.category || "");
        });
    }

    public addObserver(observer: any) {
        if (observer) {
            this.observers.push(observer);
        }
    }

    public removeObserver(observer: any) {
        if (observer) {
            this.observers.remove(observer);
        }
    }

    private notifyObservers() {
        for (let i = 0; i < this.observers.length; i++) {
            this.observers[i].update();
        }
    }

    public updateReferences(categoryID: string) {
        this.closeDropdown();

        router.replace(`/${categoryID}`);
        this.currentCategory = categoryID;
        this.updateCurrentCategoryDisplayName();
        this.notifyObservers();

        this.isInitialized = true;

    }


    private updateCurrentCategoryDisplayName() {
        const categoriesArray = this.categories.categories;
        if (this.currentCategory === "") {
            this.currentCategoryDisplayName = this.allText;
        } else {
            if (categoriesArray) {
                for (let i = 0; i < categoriesArray.length; i++) {
                    if (categoriesArray[i].id === this.currentCategory) {
                        this.currentCategoryDisplayName = categoriesArray[i].displayName;
                    }
                }
            }
        }
    }


    public toggleDropdown() {
        this.dropdownOpen = !this.dropdownOpen;
    }
    public closeDropdown() {
        this.dropdownOpen = false;
    }
}

function getCategories(language: string): Promise<any> {
    return fetch(`${window.mgnlContextPath}/.rest/suan/v1/news/categories`, {
        credentials: "include",
        method: "PUT",
        cache: "no-cache",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
        },
        body: JSON.stringify({
            language,
        }),
    }).then(response => response.json());
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/scripts/news-overview.ts